export default __webpack_public_path__ + "static/media/placeholder-diamond.74bda09b.png";